















































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {FormRowWings, SelectWings, FieldTooltip, InputWings, TextareaWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {BlacklistContactItem} from "@/store/blacklists/types";
import { getTranslatedParams } from "@/utils/notify-utils";
import { ActionLog } from "@/store/auth/types";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {FormRowWings, SelectWings, FieldTooltip, InputWings, TextareaWings}})
export default class BlackListContact extends Vue {
  @Ref('validator') validator:any;
  @Getter("blacklistContacts") blacklistContactsResponse: any;
  @Getter("blacklistItem") blacklistItem: any;
  @Action("saveBlackListContact") actionSave: any;
  @Action("deleteBlackListContact") actionDelete: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}
  private item:BlacklistContactItem=Object.create({})
  private itemSaved:BlacklistContactItem=Object.create({})

  async created() {
    if (this.$route.params.contactId) {
      const data = this.blacklistContactsResponse
          .find((blc:BlacklistContactItem) => blc.id?.toString() === this.$route.params.contactId)
      if (data) {
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      }
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({id: this.$route.params.contactId, blackListId: this.blacklistItem?.name})
      }
      await this.actionLog(this.logObject)
    }
  }

  back() {
    this.$router.push(`/black_list/group/${this.$route.params.id}/contact`);
  }

  onSaveItem():Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: this.$route.params.contactId ? "Editing" : "Creation",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({...this.item, id: this.$route.params.contactId, blackListId: this.blacklistItem?.name})
        }
        await this.actionSave({
          id: this.$route.params.contactId,
          blackListId: this.$route.params.id,
          ...this.item
        });
        this.itemSaved = cloneDeep(this.item);
        await this.actionLog(this.logObject)
        resolve();
        this.back();
      } catch (error) {
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        reject()
      }
    })
  }

  async onDeleteItem():Promise<void> {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({id: this.$route.params.contactId, blackListId: this.blacklistItem?.name})
      }
      await this.actionDelete({
        params: {blackListId: this.$route.params.id},
        data: {contactIds: [this.$route.params.contactId]}
      })
      this.itemSaved = this.item;
      await this.actionLog(this.logObject)
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
